import React, { Component } from "react";

import { connect } from "react-redux";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

class QuantityBoxDialog extends Component {
  state = { modalQuantity: this.props.quantity };
  editQuantity = (e) => {
    this.props.changeQuantity(this.state.modalQuantity);
    this.props.closeModal();
  };

  render() {
    const { quantity } = this.props;
    return (
      <Dialog
        onClick={(e) => {
          e.stopPropagation();
        }}
        onClose={(e) => {
          e.stopPropagation();
          this.props.closeModal();
        }}
        open={true}
      >
        <DialogContent>
          <form noValidate autoComplete="off" onSubmit={this.editQuantity}>
            <TextField
              inputProps={{
                className: "text-center",
              }}
              autoFocus
              fullWidth
              margin="dense"
              type="number"
              variant="outlined"
              onChange={(e) => {
                this.setState({
                  modalQuantity: e.target.value.replace("-", ""),
                });
              }}
              defaultValue={quantity || undefined}
            />
            <Button
              className={`my-1  mx-auto`}
              variant="contained"
              color="primary"
              type="submit"
              style={{
                boxShadow: "none",
                width: "100%",
                textTransform: "none",
              }}
              dir={this.props.language == "english" ? "ltr" : "rtl"}
            >
              {this.props.language === "arabic" ? "إتمام" : "Ok"}
            </Button>
          </form>
        </DialogContent>
      </Dialog>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    usedComponents: state.store.used_components,
  };
};

export default connect(mapStateToProps)(QuantityBoxDialog);
